<div fxLayout="column" fxLayoutAlign="end stretch" fxFlex>
    <div class="state">
        {{'Carregando componentes do HTML5' | translate}}...
    </div>
    <mat-progress-bar mode="determinate" color="accent" [value]="progress"></mat-progress-bar>
</div>
